// טיפוסים עבור מקבץ שאלות (SClassTest) והשאלות שבתוכו (IvrField)

export type IvrFieldType =
    | 'STT'   // זיהוי דיבור
    | 'GSTT'  // זיהוי דיבור Gemini AI
    | 'INT'   // הקשת מספרים
    | 'AMT'   // סכום / כמות
    | 'DIG'   // ספרה / שאלון אמריקאי
    | 'SEL'   // בחירה (0-9)
    | 'MSEL'  // בחירה מורחבת
    | 'REC'   // הקלטה
    | 'SC'    // הזנת ניקוד
    | 'RZ'    // רישום לצינתוק
    | 'EML';  // הזנת אימייל

export const IVR_FIELD_TYPE_OPTIONS: { value: IvrFieldType; label: string }[] = [
    {value: 'STT', label: 'זיהוי דיבור'},
    {value: 'GSTT', label: 'זיהוי דיבור Gemini AI'},
    {value: 'INT', label: 'הקשת מספרים'},
    {value: 'AMT', label: 'סכום / כמות'},
    {value: 'DIG', label: 'ספרה / שאלון אמריקאי'},
    {value: 'SEL', label: 'בחירה (0-9)'},
    {value: 'MSEL', label: 'בחירה מורחבת'},
    {value: 'REC', label: 'הקלטה'},
    {value: 'SC', label: 'הזנת ניקוד'},
    {value: 'RZ', label: 'רישום לצינתוק'},
    {value: 'EML', label: 'הזנת אימייל'},
];

export interface GeminiSttSettings {
    gemini_api_key?: string;
    gemini_language?: string;
    gemini_model?: string;
    gemini_prompt_type?: 'basic' | 'custom' | string;
    gemini_custom_prompt?: string;
    gemini_num_speakers?: number | null;
}

export interface SttSettings {
    stt_language?: '' | 'he-IL' | 'en-US';
}

export type IvrFieldSettings = GeminiSttSettings & SttSettings & Record<string, any>;

export interface IvrField {
    id: number;
    sclass_test: number;
    desc: string;
    type: IvrFieldType;

    field_speach_id: number | null;
    qa_correct_sound_id: number | null;
    qa_failed_sound_id: number | null;
    qa_after_sound_id: number | null;

    order: number | null;
    correct_answer: number | null;
    score: number | null;
    to_confirm: boolean;
    loop: boolean;
    timeout: number | null;

    max_digits: number | null;
    min_digits: number | null;

    note: string | null;
    option_rules: string | null;

    correct_options: string[] | null;
    goto_options: string[] | null;

    settings: IvrFieldSettings | null;
    advanced_modules: string | null;

    create_date?: string;
    update_date?: string;
}

export type IvrFieldPayload = Partial<Omit<IvrField, 'id'>> & { sclass_test: number };

export interface SClassTest {
    id: number;
    sclass: number | null;
    sclass_name: string | null;
    description: string | null;
    field_speach_id: number | null;
    start_date: string | null;
    end_date: string | null;
    is_active: boolean;
    here_score: boolean;
    max_score: number | null;
    settings: Record<string, any> | null;
    create_date?: string;
    questions_count?: number;
}

// אפשרות בחירה של שלוחה (SClass) - לשימוש בבחירת השלוחה של מקבץ השאלות
export interface SClassOption {
    id: number;
    name: string;
}


